import { clsx } from 'clsx'
import { Link } from 'component/Link'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import css from 'page/ProfileScreen/ErrorPopover/ErrorPopover.module.scss'
import { useEffect, useRef } from 'react'
import { SelfieStore } from 'store/profile/SelfieStore'
import { store } from 'store/store'

type FailProps = {
  selfie: SelfieStore
  full?: boolean
}

export const ErrorPopover = observer(({ selfie, full }: FailProps) => {
  const { err } = selfie
  const { title, desc, tips } = err || {}
  const ref = useRef<HTMLDivElement>(null)
  const className = clsx(css.popover, full && css.full)

  const onHelp = useLatestCallback(() => {
    store.profile.step = 'help'
  })

  const onClose = useLatestCallback(() => {
    selfie.setError(undefined)
  })

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const { top } = element.getBoundingClientRect()
    if (top < 60) {
      element.style.marginTop = Math.ceil((60 - top)) + 'px'
    }
  })

  if (!err) return null

  return <Space ref={ref} className={className}>
    <Space className={css.content}>
      <Space className={css.line} />
      <Vertical gap={4} spring>
        <Typo size={14} semi>
          {title}
        </Typo>
        <Typo size={12} secondary pre>
          {desc}
        </Typo>
        {tips && <Link className={css.link} action={onHelp}>
          <Typo size={14} medium wrap>
            {i18n('TipsForTakingGoodPhoto')}
          </Typo>
        </Link>}
      </Vertical>
      <Space className={css.close} size={16} onClick={onClose}>
        <Icon size={16} name="close" secondary />
      </Space>
    </Space>
    {!full && <Space className={css.arrow} />}
  </Space>
})
